"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const rich_text_1 = require("@vedalib/rich-text");
const toMarkdown = (element, context) => {
    var _a;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.items) || element.value.items.length === 0) {
        return '';
    }
    const { items } = element.value;
    const lines = [];
    lines.push('**Match the following:**');
    lines.push('');
    const padCell = (text, minWidth = 20) => {
        return text.padEnd(minWidth, ' ');
    };
    lines.push(`| ${padCell('Left side')} | ${padCell('Right side')} |`);
    lines.push(`| ${padCell('---', 20)} | ${padCell('---', 20)} |`);
    items.forEach((item) => {
        const leftLabel = item.leftLabel
            ? (0, rich_text_1.slateToMarkdown)(item.leftLabel, {
                allowHtmlStyles: context.withStyle,
                allowAlignment: context.withStyle,
                allowCaptionHtml: context.withStyle,
            })
                .trim()
                .replace(/\n/g, ' ')
            : '';
        const rightLabel = item.rightLabel
            ? (0, rich_text_1.slateToMarkdown)(item.rightLabel, {
                allowHtmlStyles: context.withStyle,
                allowAlignment: context.withStyle,
                allowCaptionHtml: context.withStyle,
            })
                .trim()
                .replace(/\n/g, ' ')
            : '';
        if (!leftLabel || !rightLabel) {
            return;
        }
        lines.push(`| ${padCell(leftLabel)} | ${padCell(rightLabel)} |`);
    });
    if (lines.length === 4) {
        return '';
    }
    return lines.join('\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
